// Styles
import LeverageCollateralFutureContainer from "./LeverageCollateralFuture.styles";
import ReportsTab from "../../../../components/Screens/DailyRecs/DailyFlowsCheck/ReportsTab/ReportsTab";
import AlertsTab from "../../../../components/Screens/DailyRecs/DailyFlowsCheck/AlertsTab/AlertsTab";
import ChangeLogTab from "../../../../components/Screens/DailyRecs/DailyFlowsCheck/ChangeLogTab/ChangeLogTab";
import Tabs from "../../../../components/Common/Tabs/Tabs";

interface LeverageCollateralFutureProps {}

const checkName = "leverage_collateral";

const LeverageCollateralFuture = ({}: LeverageCollateralFutureProps) => {
    return (
        <LeverageCollateralFutureContainer>
            <p className={"sectionTitle"}>LEVERAGE + COLLATERAL + FUTURE</p>
            <Tabs
                defaultTab="reports"
                tabs={[
                    {
                        value: "reports",
                        title: "REPORTS",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <ReportsTab reportId="7ed1b71c-6735-483a-af2f-6a6e3acb3a22" workspaceId="a42e71f1-8daa-48e5-a1d6-ad5674016128"/>,
                    },
                    {
                        value: "alerts",
                        title: "ALERTS",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <AlertsTab checkName={checkName} />,
                    },
                    {
                        value: "change_log",
                        title: "CHANGE LOG",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <ChangeLogTab checkName={checkName} />,
                    },
                ]}
            />
        </LeverageCollateralFutureContainer>
    );
};

export default LeverageCollateralFuture;
